import styled from "@emotion/styled";
import YouTube from "@vip30/react-youtube";

export const Container = styled.div`
  margin-block-start: 12px;
`;

export const VideoContainer = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 0;
  max-inline-size: 100%;
  padding-block-end: 56.25%;
`;

export const StyledYouTube = styled(YouTube)`
  position: absolute;

  inline-size: 100%;
  block-size: auto;

  iframe {
    aspect-ratio: 16 / 9;

    inline-size: 100%;
    block-size: 100%;
  }
`;

export const AdContainer = styled.div`
  inline-size: 100% !important;
  block-size: 0;
  padding-block-end: 56.25%;

  /* Override the inline style generated by IMA SDK */
  .ima-control-button {
    padding-block: 0;
    padding-inline: 6px;
  }
  .ima-controls,
  div > div,
  iframe {
    z-index: 1;
  }

  div > div {
    inline-size: 100% !important;
    block-size: 100% !important;
  }
  iframe {
    position: absolute !important;
    inset-block-start: 0;
    inset-inline-start: 0;

    inline-size: 100%;
    block-size: calc(100% - 40px);
  }
`;
